export default "__VITE_ASSET__8e266a17__"